
export function formatNumber(value, maximumFractionDigits = 2) {
    return new Intl.NumberFormat('en-AU', { maximumFractionDigits }).format(value);
}